import React, { Component } from 'react';
import ActivityModal from './activity-modal';
import HoursOfServiceModal from './hours-of-service-modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showModalAction, fetchNotes, setNotesObj, getWorkdayAction, actErrorAction } from '../actions/index';
import * as constants from '../const';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import moment from 'moment';
import notesPresentIcon from '../../../src/assets/images/notes-present.png';
import notesDisabledIcon from '../../../src/assets/images/notes-disabled.png';
import notAmendedIcon from '../../../src/assets/images/NotAmended.png';
import amendedIcon from '../../../src/assets/images/Amended.png';
import editPenIcon from '../../../src/assets/images/editPen.png';


class Workday extends React.Component {

    constructor(props) {
        super(props);
       
    }

    // rendering modals as needed
    showModal(modalObj) {
        if(modalObj == 'notes_Modal'){
            this.setNotesObj(modalObj)
        } else {
            var workday = this.props.workday;
            var menuType = this.props.menutype;
            if (menuType != "HosDetails" && !workday.IsHOSLogCertified && this.props.role === constants.roles.EMPLOYEE_ROLE ) {
                alert('To View/Edit you need to be current on all HOS certifications before today.');
                return;
            }

           this.getWorkdayDetails(modalObj);
        }
    };

   showHosDetailsModal(modalObj)
   {

    if(modalObj == 'notes_Modal'){
        this.setNotesObj(modalObj)
    } else {
        let workday = this.props.workday;
        let menuType = this.props.menutype;

        if(this.props.workday.UncertifiedStartDate)
        {
            let uncertifiedStartDate = this.props.workday.UncertifiedStartDate


            let canCertifyHistoricalDate = moment(workday.wdy_date, "MM/DD/YYYY").isAfter(moment(uncertifiedStartDate, "YYYY-MM-DD"));    
    
            if (menuType = "HosDetails" && canCertifyHistoricalDate && this.props.role === constants.roles.EMPLOYEE_ROLE ) {
                alert('To View/Edit you need to be current on all HOS certifications from ' + moment(uncertifiedStartDate, "YYYY-MM-DD").format("MM/DD/YYYY") +'.');
                return;
            }
        }
         

        this.getWorkdayDetails(modalObj)
    }

   }


   getWorkdayDetails(modalObj)
   {
    var workday = this.props.workday;
    var menuType = this.props.menutype;  

    this.props.onShowModal(modalObj.modalName);
    this.props.onActErr(false, false);
     var workdayDate = moment(modalObj.workdayDate, 'MM/DD/YYYY')
     workdayDate = workdayDate.format('YYYYMMDD');
     let role = this.props.role,
        self = this;
     let url = this.props.menutype == "HosDetails" ? constants.actionUrls.HOS_LOG_DETAILS : constants.actionUrls.WORKDAY_URL;
     url = url + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
     + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus;
     if(workday.isPayDetail){
         url = url+ "/" + workday.isPayDetail + "/" + workday.RestBreakNo
     }
     this.props.getWorkday(
        url,
      function(response){
        if(response){
            if(response.latestRecords == false){
                let latestRecords = response.latestRecords;
                self.props.onActErr(true, false, response.errMsg, false);
            }
        }
      });
   }


    setNotesObj(modalObj)
    {
        var workday = this.props.workday,
        workdayDate = moment(workday.wdy_date, 'MM/DD/YYYY')
        workdayDate = workdayDate.format('YYYYMMDD'),
        modalObj = {
            workdayId:workday.id,
            empId:workday.demp_display_id,
            workdayDate:workdayDate,
            modalName:"notes_Modal",
            showNotesModal:true,
            notes:workday.notes
        }
    this.props.setNotesObj(modalObj);
    }

   


    // render certify status
    renderAction() {  
          
            var workday = this.props.workday;            
            let confirmText= (workday.wdy_certify_type && workday.wdy_certify_type.trim() ==='Certify')? constants.CONFIRM_TXT:workday.wdy_certify_type;            

            let certifyTxt = workday.dutyActivityStatus == 'N' ? workday.wdy_certify_type ? confirmText: 'OFF' : 
                        workday.wdy_certify_status == constants.CERTIFIED ? workday.wdy_date : workday.wdy_certify_type ? confirmText : constants.CONFIRM_TXT; 
                        
        var colorCode = function(){
            if(workday.dutyActivityStatus == 'N'){
                return constants.COLORS.Black;
            } else if(workday.wdy_certify_status == constants.UNCERTIFIED){
                return constants.COLORS.Green;
            } else if(workday.wdy_certify_status == constants.CLAIM){
                return constants.COLORS.Orange;
            }
        }
        var modalObj = {
            workdayId:workday.id,
            certifyStatus:workday.wdy_certify_status,
            empId:workday.demp_display_id,
            workdayDate:workday.wdy_date,
            modalName:constants.hosModals.Certify_Modal,
            dutyActivityStatus:workday.dutyActivityStatus
        }

        if (workday.wdy_certify_status == constants.UNCERTIFIED) {
            return (
                <div>
                    <a className={"pointer " + (workday.dutyActivityStatus == "N" ? "underline" : "")} style={{"color": colorCode()}} onClick={() => this.showModal(modalObj)}>
                        {certifyTxt }
                    </a>
                </div>
            );
        }
        else {
            modalObj.modalName = constants.hosModals.Certified_Modal;
            return (
                <div>
                    <a className="pointer" onClick={() => this.showModal(modalObj)}>
                        {workday.wdy_certify_status == constants.CLAIM ? <span className="red" style={{"color": colorCode()}}>View-C </span> :
                            "View"}
                    </a>
                </div>
            )
        }
    }

    rendeStatusForHosLog() {
        var workday = this.props.workday,
            certifyTxt = workday.dutyActivityStatus == 'N' ? 'OFF' : 
                this.props.authDetails.role != constants.roles.EMPLOYEE_ROLE ? 'Not Certified' :constants.CERTIFY_TXT


        var colorCode = function(){
            if(workday.dutyActivityStatus == 'N'){
                return constants.COLORS.Black;
            } else if(workday.wdy_certify_status == constants.UNCERTIFIED){
                return constants.COLORS.Green;
            }
        }
        var modalObj = {
            workdayId:workday.id,
            certifyStatus: workday.isPayDetail == '1' ? workday.wdy_certify_status_pay : workday.wdy_certify_status,
            empId:workday.demp_display_id,
            workdayDate:workday.wdy_date,
            modalName:constants.hosModals.Certify_Modal,
            dutyActivityStatus:workday.dutyActivityStatus
        }
        if (workday.wdy_certify_status == constants.UNCERTIFIED) {
            return (
                <div>
                    <a className={"pointer " + (workday.dutyActivityStatus == "N" ? "underline" : "")} style={{"color": colorCode()}} onClick={() => this.showHosDetailsModal(modalObj)}>
                        { certifyTxt }
                        {this.props.isEditable ?
                            <img className="notesIcon" src={editPenIcon}/>
                            : null}
                    </a>
                </div>
            );
        }
        else {
            modalObj.modalName = constants.hosModals.Certify_Modal;
            return (
                <div>
                    <a className="pointer" onClick={() => this.showModal(modalObj)}>
                        {workday.IsAmendment == '1' ? 'Amendment-' + workday.AmendmentId +' ' : workday.Created_By == 'system' ? 'Certified-s' : 'Certified'}
                        {this.props.isEditable ?
                            <img className="notesIcon" src= {editPenIcon}/>
                            : null}
                    </a>
                </div>
            )
        }
    }

    renderAmendedIcon() {
        var workday = this.props.workday;
        return <img className="notesIcon" src={workday.wdy_certify_status == constants.UNCERTIFIED ? notAmendedIcon: amendedIcon}/>;
         
    };

    render() {
       
        
        var workday = this.props.workday,
            timeOffPrior = workday.wdy_previous_time_off == null || workday.dutyActivityStatus && workday.dutyActivityStatus == 'N' ? '-' : workday.wdy_previous_time_off,
            notesPresent = workday.notes && workday.notes !=null,
            menuType = this.props.menutype;   
        const isMenumappingConf = this.props.authDetails.activeMenus && Array.isArray(this.props.authDetails.activeMenus) && this.props.authDetails.activeMenus.length > 0 ;
        const parialClassname = isMenumappingConf ? "text-center hidden" : "text-center";
                   // toDo refactor render 
        if (menuType == "HosDetails") {
           
            return (  
                       
                <Tr key={workday.demp_display_Id + workday.wdy_date}
                    id={workday.demp_display_Id + workday.wdy_date}>
                        
                    <Td className={this.props.extraCell ? "" : "hidden"} >{this.props.extraCell ? this.props.extraCell : null}</Td>  
                    <Td className="hidden"><a className="pointer" onClick={() => this.showModal('notes_Modal')}>
                        <img className="notesIcon" src={notesPresent ? notesPresentIcon : notesDisabledIcon} />
                        </a>
                    </Td>
                    <Td>{workday.wdy_date} </Td>
                    <Td>{workday.RestBreakNo == 1 ? 
                            workday.IsAmendment == '1' ? 'Amendment-' + workday.AmendmentId : 'First Start' 
                            : workday.RestBreakNo == 2 ? workday.IsAmendment == '1' ? 'Amendment-' + workday.AmendmentId : 'Second Start' : ''} </Td>
                    <Td className="hidden">{workday.wdy_14dayValue} </Td>                    
                    <Td className="text-center">
                    {
                        
                    workday.wdy_working_time_hos_adjust && (workday.wdy_certify_status.trim()==='C') ? workday.wdy_working_time_hos_adjust.toLowerCase().lastIndexOf('m') > 0?workday.wdy_working_time_hos_adjust:workday.wdy_working_time_hos_adjust.trim().toUpperCase() + 'M': ""
                    }
                    </Td>
                    <Td className="text-center">
                    {
                        this.rendeStatusForHosLog()
                    }
                    </Td>
                </Tr>
            );
        } else {
            
            return (         
                <Tr key={workday.demp_display_Id + workday.wdy_date}
                    id={workday.demp_display_Id + workday.wdy_date}>
                    <Td><a className="pointer" onClick={() => this.showModal('notes_Modal')}>
                        <img className="notesIcon" src={notesPresent ? notesPresentIcon : notesDisabledIcon} />
                        </a>
                    </Td>
                    <Td>{workday.wdy_date} </Td>
                                
                
                    <Td className="text-center">{workday.wdy_job_symbol ? workday.wdy_job_symbol : '-' }</Td>
                
                    <Td className={parialClassname}>{workday.job_type}</Td>
                    <Td className={parialClassname}>{timeOffPrior} </Td>
                    <Td className={parialClassname}>
                        {workday.wdy_working_time_hos_adjust ? workday.wdy_working_time_hos_adjust : workday.wdy_working_time_hos}
                    </Td>
                    
                    <Td className="text-center">
                        {workday.wdy_spread_adjust ? workday.wdy_spread_adjust : workday.wdy_spread}
                    </Td>
                    
                    <Td className="text-center">
                    {
                        this.renderAction()
                    }
                    </Td>
                </Tr>
            );
        }
    }
}

function mapStateToProps(state) { // coming from store
    return {
        authDetails:state.authState
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onShowModal: showModalAction,
            getWorkday: getWorkdayAction,
            onActErr: actErrorAction,
            setNotesObj:setNotesObj
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Workday);
